
export enum TextControlSearchValueEnum {
    TITLE,
    CONTENT
}



// WEBPACK FOOTER //
// ./src/vas/controls/text/text-control-search-value.enum.ts